<h1 mat-dialog-title>Reason for Change</h1>
<div mat-dialog-content>
  <mat-form-field style="width:100%">
    <mat-label>Enter reason for update</mat-label>
    <textarea style="resize:none" rows="4" cols="28" autocomplete="off" matInput [maxLength]="maxCharacterLength" [(ngModel)]="data.reason" id="updateValidationInput"></textarea>
    <mat-hint align="end">{{data.reason.length}} / {{maxCharacterLength}}</mat-hint>
  </mat-form-field>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button (click)="onNoClick()" id="updateValidationCancelButton">Cancel</button>
  <button mat-button [disabled]="data.reason && data.reason.trim().length<3" [mat-dialog-close]="data.reason" cdkFocusInitial id="updateValidationOkButton">Ok</button>
</div>
